import WebinarPaymentHistory from "../section/paymenthistorypage/WebinarPaymentHistory";

export default function WebinarPaymentHistoryPage() {
    return (
        <WebinarPaymentHistory />
    );
}
